import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';

@Component({
  selector: 'app-editar-cliente',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './editar-cliente.component.html',
  styleUrl: './editar-cliente.component.css',
  standalone: true
})
export class EditarClienteComponent implements OnInit {
 form!: FormGroup;
  clienteId!: number;
  error = '';
  loading = false;
  usuarioId: number = 0;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private clienteService: ClienteService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit() {
    this.clienteId = +this.route.snapshot.paramMap.get('id')!;
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      telefono: ['', Validators.required],
      email : ['', Validators.required]
    });

    this.cargarCliente();
  }

  cargarCliente() {
    const usuarioId = this.currentUserService.getUsuarioId();
    if (!usuarioId) {
      alert('Debes iniciar sesión para acceder a esta sección.');
      this.router.navigate(['/login']);
      return;
    }
    this.usuarioId += usuarioId;
    this.clienteService.obtenerClientePorId(this.usuarioId,this.clienteId).subscribe({
      next: (cliente) => {
        this.form.patchValue({
          nombre: cliente.nombre,
          telefono: cliente.telefono,
          email: cliente.email
        });
      },
      error: () => this.error = 'Error al cargar cliente'
    });
  }

  submit() {
    if (this.form.invalid) return;

    this.loading = true;
    this.clienteService.updateCliente(this.clienteId, this.form.value).subscribe({
      next: () => {
        this.loading = false;
        alert('Cliente actualizado correctamente');
        this.router.navigate(['/dashboard']);
      },
      error: () => {
        this.error = 'Error al actualizar cliente';
        this.loading = false;
      }
    });
  }
  volverAtras() {
    this.router.navigate(['/cliente']);
  }
}
